import React, { useState } from 'react';
import {
  FiThumbsUp,
  FiThumbsDown,
  FiAlertCircle,
  FiShield,
  FiZap,
  FiChevronDown,
  FiFilter,
} from 'react-icons/fi';

import { TopBar } from '@/design-system/components/organisms/TopBar';
import { ConversionChart } from '@/features/onboarding/components/ConversionChart';
import { MetricCard } from '@/features/onboarding/components/MetricCard';
import { RefusalReasonsList } from '@/features/onboarding/components/RefusalReasonsList';
import { Sidebar } from '@/features/onboarding/components/Sidebar';
import { ONBOARDING_SIDEBAR_ITEMS } from '@/shared/constants/sidebar.constants';

export const OnboardingDashboardPage: React.FC = () => {
  const [dateFilter, setDateFilter] = useState<string>('');

  const conversionData = [
    { label: 'Aprovação Manual', percentage: 25, color: '#059669' },
    { label: 'Aprovação Sistema', percentage: 15, color: '#10b981' },
    { label: 'Reprovação Manual', percentage: 15, color: '#dc2626' },
    { label: 'Reprovação Sistema', percentage: 23, color: '#ef4444' },
  ];

  const refusalReasons = [
    {
      reason: 'Dicotomica: Apontamentos DICT acima do esperado',
      percentage: 100,
      color: '#ef4444',
    },
    {
      reason: 'Dicotomica: Apontamentos RUFRA acima do esperado',
      percentage: 80,
      color: '#ef4444',
    },
    {
      reason: 'Dicotomica: Reprovado automaticamente pelo sistema',
      percentage: 60,
      color: '#ef4444',
    },
    {
      reason: 'Dimensa: Com apontamento Receita Federal',
      percentage: 40,
      color: '#ef4444',
    },
    {
      reason: 'Pendência Cadastral na Receita Federal: CPF/CNPJ Suspenso',
      percentage: 20,
      color: '#ef4444',
    },
  ];

  return (
    <div className="min-h-screen bg-neutral-50">
      <TopBar />

      <div className="flex">
        {/* Sidebar */}
        <Sidebar items={ONBOARDING_SIDEBAR_ITEMS} className="w-64 min-h-[calc(100vh-140px)]" />

        {/* Main Content */}
        <main className="flex-1 p-8">
          <div className="max-w-7xl mx-auto">
            {/* Date Filter */}
            <div className="flex  mb-2">
              <div className="relative">
                <select
                  value={dateFilter}
                  onChange={(e) => { setDateFilter(e.target.value); }}
                  className="appearance-none bg-white border-2 border-purple-600 rounded-lg pl-12 pr-12 py-3 text-base font-medium text-neutral-800 cursor-pointer hover:bg-purple-50 transition-colors focus:outline-none focus:ring-2 focus:ring-purple-500"
                >
                  <option value="" disabled>
                    Data
                  </option>
                  <option value="day">Dia</option>
                  <option value="month">Mês</option>
                  <option value="year">Ano</option>
                </select>
                <FiFilter className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-purple-600 pointer-events-none" />
                <FiChevronDown className="absolute right-4 top-1/2 -translate-y-1/2 w-5 h-5 text-purple-600 pointer-events-none" />
              </div>
            </div>

            {/* Top Metrics Row */}
            <div className="grid grid-cols-3 gap-6 mb-6">
              <MetricCard
                title="Para analisar - 24h restante"
                value="12"
                icon={<FiAlertCircle />}
                type="warning"
              />
              <MetricCard title="Para analisar" value="33" icon={<FiZap />} type="default" />
              <MetricCard
                title="Últimas contas aprovadas"
                value="17"
                icon={<FiThumbsUp />}
                type="success"
              />
            </div>

            {/* Second Metrics Row */}
            <div className="grid grid-cols-3 gap-6 mb-6">
              <MetricCard title="Aprovados (Total)" value="100" icon={<FiThumbsUp />} type="info" />
              <MetricCard
                title="Reprovados (Total)"
                value="22"
                icon={<FiThumbsDown />}
                type="danger"
              />
              <MetricCard title="Blocklist (Total)" value="40" icon={<FiShield />} type="warning" />
            </div>

            {/* Charts Section */}
            <div className="grid grid-cols-2 gap-6">
              <ConversionChart title="Taxa de conversão (Hoje)" data={conversionData} />
              <RefusalReasonsList title="Motivos de recusa (Top 5)" data={refusalReasons} />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};
